/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* eslint-disable no-duplicate-imports */
import * as React from 'react';

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import { IStoreSelectorViewProps } from './citta-store-selector';

const StoreSelectorView: React.FC<IStoreSelectorViewProps> = props => {
    const {
        BodyContainerProps,
        FooterContainerProps,
        HeaderContainerProps,
        HeaderProps,
        ModuleProps,
        // headerText,
        locationsMessage,
        search,
        state,
        spinner,
        locationsList,
        noLocationsMessage,
        terms } = props;

    return (
        <Module {...ModuleProps} >
            <Node {...HeaderContainerProps}>
                {HeaderProps}
            </Node>
            <Node {...BodyContainerProps}>
                {locationsMessage}
                {search}
                {state.isSearchInProgress ?
                    spinner :
                    <>
                        {locationsList ? locationsList : noLocationsMessage}
                    </>
                }
            </Node>
            <Node {...FooterContainerProps}>
                {terms}
            </Node>
        </Module>
    );
};

export default StoreSelectorView;
